import { call, put, select, takeLatest } from "redux-saga/effects";
import { EVALUATION_DATA_REQUEST, MEDICAL_RECORD_DATA_REQUEST, QUICKFILTER_DATA_REQUEST, EVALUATION_ADJUSTMENT_DATA_REQUEST, KNOWLEDGE_CENTRE_DATA_REQUEST, 
  REASON_CODE_DATA_REQUEST, EVALUATION_DETAILS_DATA_REQUEST, OVERTURNS_DATA_REQUEST } from "@src/middleware/actions/actionTypes";
import { fetchEvaluationDataError, fetchEvaluationDataSuccess, fetchMedicalRecordDataSuccess, getQuickFilterDataSuccess, fetchEvaluationAdjustmentDataSuccess, getQuickFilterDataError, knowLedgeCentreDataSuccess, knowLedgeCentreGlosasryList, fetchEvaluationDetailsDataSuccess, fetchEvaluationDataLoading, reasonCodeTableDataLoading, fetchEvaluationAdjustmentDataLoading, fetchMedicalRecordDataloading, fetchOverturnsDataSuccess, fetchOverturnsDataLoading } from "../../../actions/Reimbursement/paymentIntegrityActions";
import { isLoading } from "../../../actions/SiteOfServiceAction";
import { getMetricsDataKc } from "@src/utility/common.service";
import { setTableData } from "../../../actions/genericActions/tableActions";
import { getAuditReasonData, getEvaluationAdjustmentData, getEvaluationData, getMedicalRecordData, getPaymentIntegrityQuickFilters, getPIEvaluationDetailsdAPIData, getOverturnsData } from "@src/middleware/services/reimbusement/paymentIntegrity/paymentIntigrity.service";
import { checkHCO } from "@src/utility/createStorage";
import { getQuickFiltersTinList } from "@src/apps/CallPage/Main/Main.service";


function* fetchEvaluationData(action: any) {
  try {
      yield put(fetchEvaluationDataLoading(true));

     let response = yield call(getEvaluationData, action?.payload);

    if (response?.status === 504) {
      response = yield call(getEvaluationData, action?.payload);
    }
    const data = response?.Data?.[0];

    if (!data) {
      yield put(fetchEvaluationDataSuccess(undefined));
      yield put(fetchEvaluationDataError("No data available."));
      
    } else {
      yield put(fetchEvaluationDataSuccess(data));
    }

  } catch (error) {
    if (error?.response?.status === 504) {
      yield put(fetchEvaluationDataSuccess(undefined));
      yield put(fetchEvaluationDataError("Server timeout. Please try again later."));
    } else {
      yield put(fetchEvaluationDataError(error));
    }
  } finally {
    yield put(fetchEvaluationDataLoading(false));
  }
}



export function* fetchMedicalRecordData(action: any) {
  
  try {
    yield put(fetchMedicalRecordDataloading(true));
    const response = yield call(getMedicalRecordData, action?.payload);

    if (response?.status === 504) {
      yield put(fetchMedicalRecordDataSuccess(undefined)); // Clear data

    } else if (response) {
      yield put(fetchMedicalRecordDataSuccess(response?.Data));
    }

  } catch (error) {
    if (error?.response?.status === 504) {
      yield put(fetchMedicalRecordDataSuccess(undefined)); // Clear data

    } else {
      yield put(fetchEvaluationDataError(error));
    }
  } finally {
    yield put(fetchMedicalRecordDataloading(false));
  }
}



export function* fetchQuickFiltersData(action: any) {
  try {
    const payload = action?.payload || {};
    yield put(isLoading(true));
    let response;
    // Branch based on the current flow: HCO flow versus single/multi-TIN flow.
    if (checkHCO()) {
      // HCO flow payload is expected to have: { RequestedJourney: "paymentIntegrityFilter", PaymentIntegrityFilter: { ... } }
      response = yield call(getPaymentIntegrityQuickFilters, payload);
    } else {
      // Tin flow payload is expected to have: { RequestedJourney: "provTinListFilter", ProvTinListFilter: { ... } }
      // Do not pass payload here as getQuickFiltersTinList builds its own payload.
      response = yield call(getQuickFiltersTinList);
    }
    yield put(getQuickFilterDataSuccess(response?.Data));
  } catch (error: any) {
    yield put(getQuickFilterDataError({
      message: error?.message || 'Unknown error occurred while fetching quick filters.',
      stack: error?.stack || '',
      source: 'fetchQuickFiltersData'
    }));
    console.error('Error fetching quick filters:', error);
  } finally {
    yield put(isLoading(false));
  }
}


export function* fetchEvaluationAdjustmentData(action: any) {
  try {
    yield put(fetchEvaluationAdjustmentDataLoading(true));
    const response = yield call(getEvaluationAdjustmentData, action?.payload);

    if (response?.status === 504) {
      yield put(fetchEvaluationAdjustmentDataSuccess(undefined)); // Clear data
      yield put(fetchEvaluationDataError("Server timeout. Please try again later."));
    } else if (response) {
      yield put(fetchEvaluationAdjustmentDataSuccess(response?.Data));
    }

  } catch (error) {
    if (error?.response?.status === 504) {
      yield put(fetchEvaluationAdjustmentDataSuccess(undefined)); // Clear data
      yield put(fetchEvaluationDataError("Server timeout. Please try again later."));
    } else {
      yield put(fetchEvaluationDataError(error));
    }
  } finally {
    yield put(fetchEvaluationAdjustmentDataLoading(false));
  }
}

export function* fetchOverturnsData(action: any) {
  try {
    yield put(fetchOverturnsDataLoading(true));
    const response = yield call(getOverturnsData, action?.payload);

    if (response?.status === 504) {
      yield put(fetchOverturnsDataSuccess(null)); // Clear data on timeout
    } else if (response && response?.Data) {
      yield put(fetchOverturnsDataSuccess(response?.Data));
    } else {
      yield put(fetchOverturnsDataSuccess(null)); // Clear data if no valid response
    }

  } catch (error) {
    console.error('Error fetching overturns data:', error);
    yield put(fetchOverturnsDataSuccess(null)); // Clear data on any error
  } finally {
    yield put(fetchOverturnsDataLoading(false));
  }
}

export function* getKnowLedgeCentreData(action: any) {
  try {
    const response = yield call(getMetricsDataKc, action?.payload);
    yield put(isLoading(true));
    if (response) {
      yield put(knowLedgeCentreGlosasryList(response?.Data));
      const metricData = response?.Data?.find(item => item.MetricId);
      yield put(knowLedgeCentreDataSuccess(metricData));
      yield put(isLoading(false));

    }

  } catch (error) {
    yield put(fetchEvaluationDataError(error));
    yield put(isLoading(false));
  }

}



export function* getAuditReasonDataRequest(action: any) {
  try {
    yield put(reasonCodeTableDataLoading(true));
    const response = yield call(getAuditReasonData, action?.payload);

    if (response?.status === 504) {
      // Handle 504 Gateway Timeout
      yield put(fetchEvaluationDataError("Server timeout. Please try again later."));
    } else if (response) {
      yield put(setTableData(response?.Data));
    }

  } catch (error) {
    // Optional: Check if error has a response with status
    if (error?.response?.status === 504) {
      yield put(fetchEvaluationDataError("Server timeout. Please try again later."));
    } else {
      yield put(fetchEvaluationDataError(error));
    }
  } finally {
    yield put(reasonCodeTableDataLoading(false));
  }
}

export function* fetchEvaluationDetailstData(action: any) {
 try {
    const response = yield call(getPIEvaluationDetailsdAPIData, action?.payload, action?.radioValue);
    if (response) {

      yield put(fetchEvaluationDetailsDataSuccess(response?.Data));
    }

  } catch (error) {
    console.error('fetchEvaluationDetailstData :', error)
   }

}

export function* paymentIntegritySaga() {
  yield takeLatest(EVALUATION_DATA_REQUEST, fetchEvaluationData);
  yield takeLatest(MEDICAL_RECORD_DATA_REQUEST, fetchMedicalRecordData);
  yield takeLatest(QUICKFILTER_DATA_REQUEST, fetchQuickFiltersData);
  yield takeLatest(EVALUATION_ADJUSTMENT_DATA_REQUEST, fetchEvaluationAdjustmentData);
  yield takeLatest(OVERTURNS_DATA_REQUEST, fetchOverturnsData);
  yield takeLatest(KNOWLEDGE_CENTRE_DATA_REQUEST, getKnowLedgeCentreData);
  yield takeLatest(REASON_CODE_DATA_REQUEST, getAuditReasonDataRequest);
  yield takeLatest(EVALUATION_DETAILS_DATA_REQUEST, fetchEvaluationDetailstData);



}